import { render, staticRenderFns } from "./Form2_Persona2.vue?vue&type=template&id=4356dfe0"
import script from "./Form2_Persona2.vue?vue&type=script&lang=js"
export * from "./Form2_Persona2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4356dfe0')) {
      api.createRecord('4356dfe0', component.options)
    } else {
      api.reload('4356dfe0', component.options)
    }
    module.hot.accept("./Form2_Persona2.vue?vue&type=template&id=4356dfe0", function () {
      api.rerender('4356dfe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/IMPACTA/Form2_Persona2.vue"
export default component.exports